// Copyright (c) 2016 Deere & Company

import './dealer-transfer-history-report.scss';
import React, {
    Component,
    PropTypes
} from 'react';
import Criteria from '../state/criteria';
import DealerTransferHistory from '@deere/cps-it.warranty-model-factory/lib/dealer-transfer-history';
import DealerTransferHistoryReportCriteria from './dealer-transfer-history-report-criteria';
import FavoriteIcon from '../../../shared/components/favorites/favorite-icon';
import {FormattedMessage} from 'react-intl';
import Formatting from '../state/formatting';
import GeneralSettings from '@deere/cps-it.warranty-model-factory/lib/general-settings';
import NumberOfRecordsFound from '../../../shared/components/number-of-records-found/index';
import ReportGrid from '../../shared/components/report-grid';
import ReportHeader from '../../shared/components/report-header';
import ReportHiddenColumns from '../../shared/components/report-columns';
import ReportLayout from '@deere/cps-it.warranty-model-factory/lib/report-layout';
import ShowNoResultsFound from '../../shared/components/show-no-results-found/show-no-results-found';
import View from '../state/view';
import WarrantyAgGridDatePicker from '../../shared/components/ag-grid-date-picker';
import WarrantyLoadingIndicator from '../../../shared/components/warranty-loading-indicator';
import {exportToCSV} from '../../../reports/shared/services/export-to-csv';
import {getAgGridLocaleText} from '../../../shared/utils/ag-grid-locale-text';
import {getDealerTransferHistoryColumnDefinitions} from '../report-services/column-definitions';
import {getDefaultReportLayout} from '../../shared/services/report-variant';
import {scrollToAndResizeReport} from '../../shared/services/scroll-window';

function handleHistoryToDisplayChange(event) {

    if (event.target.value) {

        const historyToDisplay = parseInt(event.target.value, 10);

        const isInRange = historyToDisplay > 0 && historyToDisplay < 1000;

        if (isInRange) {

            this.actions.updateDealerTransferHistoryCriteria('historyToDisplay', historyToDisplay);

        }

    } else {

        this.actions.resetDealerTransferHistoryCriteria();

    }

}

function handleCreateDealerHistoryReport() {

    this.actions.toggleReportIsScrollable();
    this.actions.resetSearchResults();
    this.actions.createDealerTransferHistoryReport(this.criteria);

}

function handleGridApiDefinition(params) {

    let defaultColumnState,
        defaultSortModel;

    this.actions.createAgGridApi(params.api, params.columnApi);

    if (this.selectedLayout && this.selectedLayout.name && !this.isInitialLoad) {

        const defaultLayout = this.layouts.find(layout => !layout.name);

        defaultColumnState = defaultLayout.columnState;
        defaultSortModel = defaultLayout.sortModel;

    } else {

        defaultColumnState = params.columnApi.getColumnState();
        defaultSortModel = params.api.getSortModel();

        this.actions.updateReportProperty('isInitialLoad', false);

    }

    this.actions.updateDefaultLayout(defaultColumnState, defaultSortModel);

    if (this.selectedLayout && this.selectedLayout.name) {

        params.columnApi.setColumnState(this.selectedLayout.columnState);
        params.api.setSortModel(this.selectedLayout.sortModel);
        params.api.setFilterModel(this.selectedLayout.filterModel);

    } else {

        const defaultLayout = getDefaultReportLayout(defaultColumnState, defaultSortModel);

        this.actions.updateReportProperty('selectedLayout', defaultLayout);

    }

}

function onColumnRemoved(columnEvent) {

    if (!columnEvent.visible) {

        this.actions.hideReportColumn(this.columnApi.getColumnState());

    }

}

function handleExportToCsv() {

    const fileName = 'dealer-transfer-history';

    return exportToCSV(fileName, this.gridApi);

}

function handleCriteriaReset() {

    this.actions.updateDealerTransferHistoryCriteria('historyToDisplay', 90);
    this.actions.resetSearchResults();
    this.actions.updateShowNoResultsFound(false);

}

class DealerTransferHistoryReport extends Component {

    componentWillMount() {

        this.props.actions.getReportLayouts('dealer-transfer-history');

    }

    componentDidUpdate(prevProps) {

        if (this.props.reportIsScrollable && this.props.report.length) {

            this.props.actions.resetReportIsScrollable();

            scrollToAndResizeReport();

        }

        const isFirstRun = !prevProps.report.length && !prevProps.showNoResultsFound;
        const layoutWasChanged = this.props.selectedLayout !== prevProps.selectedLayout;
        const readyToApplyLayout = this.props.selectedLayout && Object.keys(this.props.columnApi).length && this.props.isDefaultColumnStateAvailable;

        if ((isFirstRun || layoutWasChanged) && readyToApplyLayout) {

            this.props.columnApi.setColumnState(this.props.selectedLayout.columnState);
            this.props.gridApi.setSortModel(this.props.selectedLayout.sortModel);
            this.props.gridApi.setFilterModel(this.props.selectedLayout.filterModel);

        }

    }

    componentWillUnmount() {

        this.props.actions.resetSearchResults();
        this.props.actions.updateShowNoResultsFound(false);
        this.props.actions.updateDealerTransferHistoryCriteria('historyToDisplay', 90);
        this.props.actions.resetReportVariant();

    }

    render() {

        const gridOptions = {
            dateComponentFramework: WarrantyAgGridDatePicker
        };

        return (
            <section className='dealer-transfer-history'>
                <WarrantyLoadingIndicator isLoading={this.props.busyCounter > 0}/>
                <h2 className='dealer-transfer-history-title'>
                    <FormattedMessage id='DEALER_TRANSFER_HISTORY'/>
                    <FavoriteIcon
                        id='DEALER_TRANSFER_HISTORY'
                        route={this.props.pathName}
                    />
                </h2>
                <DealerTransferHistoryReportCriteria
                    canExport={this.props.report.length > 0}
                    canRunReport={this.props.criteria.historyToDisplay > 0}
                    historyToDisplay={this.props.criteria.historyToDisplay}
                    onCreateDealerHistoryReport={this.props::handleCreateDealerHistoryReport}
                    onCriteriaReset={this.props::handleCriteriaReset}
                    onExportToCsv={this.props::handleExportToCsv}
                    onHistoryToDisplayChange={this.props::handleHistoryToDisplayChange}
                />
                {this.props.report.length ?
                    <div>
                        <NumberOfRecordsFound count={this.props.report.length}/>
                        <section className='report'>
                            {this.props.isReportColumnsVisible && <ReportHiddenColumns/>}
                            <ReportHeader
                                columnApi={this.props.columnApi}
                                gridApi={this.props.gridApi}
                                reportName='dealer-transfer-history'
                            />
                            <ReportGrid
                                columnDefs={getDealerTransferHistoryColumnDefinitions()}
                                gridOptions={gridOptions}
                                localeText={getAgGridLocaleText()}
                                onColumnVisible={this.props::onColumnRemoved}
                                onGridReady={this.props::handleGridApiDefinition}
                                rowData={this.props.report}
                            />
                        </section>
                    </div> :
                    <ShowNoResultsFound showNoResultsFound={this.props.showNoResultsFound}/>
                }
            </section>
        );

    }

}

DealerTransferHistoryReport.displayName = 'DealerTransferHistoryReport';
DealerTransferHistoryReport.propTypes = {
    actions: PropTypes.object.isRequired,
    busyCounter: PropTypes.number.isRequired,
    columnApi: PropTypes.object.isRequired,
    criteria: PropTypes.instanceOf(Criteria).isRequired,
    formatting: PropTypes.instanceOf(Formatting).isRequired,
    generalSettings: PropTypes.instanceOf(GeneralSettings).isRequired,
    gridApi: PropTypes.object.isRequired,
    isDefaultColumnStateAvailable: PropTypes.bool.isRequired,
    isInitialLoad: PropTypes.bool.isRequired,
    isReportColumnsVisible: PropTypes.bool.isRequired,
    layouts: PropTypes.arrayOf(PropTypes.instanceOf(ReportLayout)).isRequired,
    pathName: PropTypes.string.isRequired,
    report: PropTypes.arrayOf(PropTypes.instanceOf(DealerTransferHistory)),
    reportIsScrollable: PropTypes.bool.isRequired,
    selectedLayout: PropTypes.instanceOf(ReportLayout),
    showNoResultsFound: PropTypes.bool.isRequired,
    views: PropTypes.arrayOf(PropTypes.instanceOf(View)).isRequired
};

export default DealerTransferHistoryReport;



// WEBPACK FOOTER //
// ./src/reports/dealer-transfer-history/components/dealer-transfer-history-report.js